import { Component, Input } from '@angular/core';
import { ProductSpecificCampaign } from 'src/app/core/interfaces/page-creator';

@Component({
  selector: 'app-specific-campaign-highlight',
  standalone: true,
  templateUrl: './specific-campaign-highlight.component.html',
  styleUrls: ['./specific-campaign-highlight.styles.scss'],
})
export class AppSpecificCampaignHighlightComponent {
  @Input() productSpecificCampaign: ProductSpecificCampaign | undefined;
  constructor() {}
}
